// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__P9fN2","label":"Radio_label__iwnll","checkMark":"Radio_checkMark__1EryH","disabled":"Radio_disabled__16X4m"};